import React from 'react';
import ZoomImage from './ZoomImage'; // Используем новый компонент
import './ProductCard.css'; // Импортируем CSS файл

const ProductCard = ({ productId, product, selectedSize, isInBasket, basketCount, updateProductCount, addToBasket, toggleFavorite, clickSize, state }) => {
  if (!product || product.id != productId) return null;

  const isFavorite = state.favorite && state.favorite.some(item => item.productid === product.id);

  return (
    <div className=''>
      <div className='cardof_col' key={product.id}>
        <ZoomImage src={product.image} alt={product.name} /> {/* Используем новый компонент */}
        <div className='cardof_info'>
          <p className='cardofinfo_name'>{product.name}</p>
          <p className='cardofinfo_cost'>{product.cost} ₽</p>
          {product.needs === 'clothes' && (
            <div className='cardofinfo_size'>
              <p className='size_option_txt'>Размер:</p>
              {['S', 'L', 'XL', 'XXL'].map((sizeOption) => (
                <button
                  key={sizeOption}
                  className={`size_option ${selectedSize === sizeOption ? 'selectedss' : ''}`}
                  onClick={() => clickSize(sizeOption, product.id)}
                >
                  {sizeOption}
                </button>
              ))}
            </div>
          )}
          <div className='product_card_buy_row'>
            {isInBasket ? (
              state.basket.filter(item => item.productid === product.id && (item.size === selectedSize || product.needs !== 'clothes')).map(item => (
                <div className='productcardrow' key={item.id}>
                  <p className='product_card_buy_minus' onClick={() => updateProductCount(item.id, -1)}>-</p>
                  <p className='product_card_buy_count'>{state.basketCounts[item.id] || basketCount}</p>
                  <p className='product_card_buy_plus' onClick={() => updateProductCount(item.id, 1)}>+</p>
                </div>
              ))
            ) : (
              <button
                key={product.id}
                className='product_card_buy_button'
                onClick={() => addToBasket(product.id, product.needs)}
                disabled={state.isAddingToBasket[product.id + selectedSize]}
              >
                в корзину
              </button>
            )}
            <div
              className={`product_card_buy_unclick ${isFavorite ? 'favorite' : 'not-favorite'}`}
              onClick={() => toggleFavorite(product.id)}
            />
          </div>
          <div className='cardofinfo_txt'>
            {(typeof product.description === 'string'
              ? (() => {
                const formattedString = product.description.replace(/{|}/g, '').replace(/',/g, '","').replace(/,'/g, '","').replace(/^'|'$/g, '').replace(/'/g, '"');
                return JSON.parse(`[${formattedString}]`);
              })()
              : product.description
            ).map((item, index) => (
              <p key={index} className='cardofinfo_txt_chapter'>
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;